import { render } from "./AppHome.vue?vue&type=template&id=03384246&scoped=true"
import script from "./AppHome.vue?vue&type=script&lang=js"
export * from "./AppHome.vue?vue&type=script&lang=js"

import "./AppHome.vue?vue&type=style&index=0&id=03384246&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-03384246"

export default script